import { render } from "./ModelFilter.vue?vue&type=template&id=09deee41&scoped=true"
import script from "./ModelFilter.vue?vue&type=script&lang=js"
export * from "./ModelFilter.vue?vue&type=script&lang=js"

import "./ModelFilter.vue?vue&type=style&index=0&id=09deee41&lang=scss&scoped=true"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09deee41"]])

export default __exports__